import { helper as buildHelper } from "@ember/component/helper"
import DateFormatter from "../lib/date-formatter"

export function fastDate(params, hash) {
  let dateString = params[0]
  let decoration = params[1]
  let dateObject = DateFormatter(dateString)
  return dateObject(decoration)
}

export default buildHelper(fastDate)
